// Copyright (c) 2022 by Move Closer

import { ValidationRules } from '../../../shared/molecules/Form'
/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const signupValidationsMap: ValidationRules = {
  acceptPrivacy: 'accepted',
  acceptContent: 'accepted',
  city: 'required_if:withDeliveryAddress,true|string|min:2',
  company: 'filled|string|min:2',
  countryCode: 'required_if:withDeliveryAddress,true||string|min:2',
  email: 'required|string|email',
  firstName: 'required|string|min:3',
  lastName: 'required|string|min:2',
  password: 'required|string|min:8|confirmed',
  passwordConfirmation: 'string',
  phoneNumber: 'required_if:withDeliveryAddress,true|string|min:9|max:13',
  postalCode: 'required_if:withDeliveryAddress,true|string|min:5|max:7',
  street: 'required_if:withDeliveryAddress,true|string|min:4',
  subscribeToNews: 'boolean',
  withDeliveryAddress: 'boolean'
}
